import React from "react";
import {TableComposable, Tbody, Td, Th, Thead, Tr} from "@patternfly/react-table";

import {AiOutlineFile, AiOutlineFileImage} from "react-icons/ai";
import {GalleryItemData} from "../../Context/ItemsProvider/ItemsProviderDomain";
import {Skeleton} from "@patternfly/react-core";
import {useItemsState} from "../../Context/ItemsProvider/ItemsProvider";

interface ViewProps{
    items: GalleryItemData[];
    selectedItems: string[];
    onClickItem: ( newId:string) => void;
}

const columnNames = {
    id: 'ID',
    name: 'Nombre',
    file_description: 'Descripción',
    created_date: 'Creado',
    human_valid: 'Válido hasta',
    human_size: 'Tamaño',
};

export const DashboardTableItems: React.FunctionComponent<ViewProps> = (props) => {
    const { isLoading} = useItemsState()

    const items = React.useMemo( ()=>{
        if( isLoading ) return null

        return props.items.map( item => (
            <Tr key={item.id}
                onClick={ ()=>{ props.onClickItem( item.id ) } }
                className={ 'selectable-row-class' + (props.selectedItems.includes( item.id ) ? ' active' : '') }>
                <Td visibility={["hiddenOnMd"]} dataLabel={columnNames.id}>{item.id}</Td>
                <Td dataLabel={columnNames.name}>
                    {
                        (item.is_image) ?
                            <AiOutlineFileImage /> :
                            <AiOutlineFile />
                    }{' '}
                    { item.name }
                </Td>
                <Td dataLabel={columnNames.file_description}>{item.file_description}</Td>
                <Td dataLabel={columnNames.created_date}>{item.created_date.format('LL')}</Td>
                <Td dataLabel={columnNames.human_valid}>{item.human_valid}</Td>
                <Td dataLabel={columnNames.human_size}>{item.human_size}</Td>
            </Tr>
        ) )
    }, [ props, isLoading ] )

    const skeleton = React.useMemo( ()=>{
        if( !isLoading ) return null

        return Array(5).fill( 1 ).map( (_value, index) => (
            <Tr key={index} >
                <Td visibility={["hiddenOnMd"]} dataLabel={columnNames.id}>
                    <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                </Td>
                <Td dataLabel={columnNames.name}>
                    <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                </Td>
                <Td dataLabel={columnNames.file_description}>
                    <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                </Td>
                <Td dataLabel={columnNames.created_date}>
                    <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                </Td>
                <Td dataLabel={columnNames.human_valid}>
                    <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                </Td>
                <Td dataLabel={columnNames.human_size}>
                    <Skeleton height="100%" width="100%" screenreaderText="Cargando Elementos" />
                </Td>
            </Tr>
        ) )
    }, [ isLoading ] )

    return (
        <TableComposable>
            <Thead>
                <Tr>
                    <Th modifier="wrap" visibility={["hiddenOnMd"]}>{ columnNames.id }</Th>
                    <Th modifier="wrap">{ columnNames.name }</Th>
                    <Th modifier="wrap">{ columnNames.file_description }</Th>
                    <Th modifier="wrap">{ columnNames.created_date }</Th>
                    <Th modifier="wrap">{ columnNames.human_valid }</Th>
                    <Th modifier="wrap">{ columnNames.human_size }</Th>
                </Tr>
            </Thead>
            <Tbody>
                { (isLoading) ? skeleton : items }
            </Tbody>
        </TableComposable>
    )
}